module.exports = __webpack_public_path__ + "img/personal-center-slide-grey1.6f42c889.svg";